"use client";
import * as React from "react";
import { Accordion as UIAccordion } from "@repo/ui-parkmobile/Accordion";
import type { Accordion } from "@/generated/sb";
import { storyblokEditable } from "@storyblok/react/rsc";
import { trackFAQClick } from "@/utils/trackingScripts";
import { textResolver } from "@/lib/storyblok/adaptors";

interface AccordionProps {
  blok: Accordion;
  section?: string;
}

export default function Accordion({ blok, section }: AccordionProps) {
  if (!blok.items || blok.items.length === 0) {
    return null;
  }

  const items = blok.items
    .map((item) => ({
      title: item.title || "",
      text: item.text?.map((textBlok) => textResolver([textBlok])),
      backgroundColor:
        item.backgroundColor === "" ? "none" : item.backgroundColor || "none",
      ...storyblokEditable(item),
    }))
    .filter((item) => item.title); // Only include items with titles

  const handleItemToggle = (index: number, title: string, isOpen: boolean) => {
    if (isOpen) {
      trackFAQClick({
        section: section || "",
        innerText: title,
        config: "accordionItem",
      });
    }
  };

  return (
    <div {...storyblokEditable(blok)}>
      <UIAccordion items={items} onItemToggle={handleItemToggle} />
    </div>
  );
}
